import {
  SignInCredentials,
  SignInResponse,
  SignUpCredentials,
  SocialLoginCredentials,
  UserSignInResponse,
} from "@/types/user";
import type { CompanyUser } from "@/types/user";
import fetcher from "@/lib/fetcher";
import { DefaultResponse } from "@/types/global";
import { buildUrlQueryParams } from "@/utils/build-url-query-params";

export interface MeApiResponse {
  data: CompanyUser;
  status: number;
}

export const authService = {
  getMe: () => fetcher<MeApiResponse>("company-users/me"),
  socialLogin: async (body: SocialLoginCredentials) =>
    fetcher.post<DefaultResponse<SignInResponse>>(
      buildUrlQueryParams(`v1/auth/${body.type}/callback`, body.data),
    ),
  signIn: async (body: SignInCredentials) =>
    fetcher.post<UserSignInResponse>("users/auth/login", {
      body,
      redirectOnError: false,
    }),
  login: async (body: SignInCredentials) =>
    fetcher.post<DefaultResponse<SignInResponse>>("v1/auth/login", { body }),
  signUpComplete: async (body: SignUpCredentials) =>
    fetcher.post<DefaultResponse<SignInResponse>>("v1/auth/after-verify", {
      body,
    }),
  phoneSignUpComplete: async (body: SignUpCredentials) =>
    fetcher.post<DefaultResponse<SignInResponse>>("v1/auth/verify/phone", {
      body,
    }),
  forgotPasswordPhone: async (body: {
    phone?: string;
    type: string;
    id?: string;
  }) =>
    fetcher.post<DefaultResponse<SignInResponse>>(
      "v1/auth/forgot/password/confirm",
      { body },
    ),
  forgotPasswordSendLink: async (body: { email: string }) =>
    fetcher.put("users/auth/forgot-password/link", { body }),
  forgotPasswordReset: async (body: { newPassword: string; token: string }) =>
    fetcher.post("users/auth/forgot-password/reset", { body }),
  logout: (data: { token: string }) =>
    fetcher.post("v1/auth/logout", { body: data }),
  refresh: () => fetcher.post("users/refresh", { retry: true }),
};
